import { render, staticRenderFns } from "./WikiApp.vue?vue&type=template&id=3eceee29&scoped=true"
import script from "./WikiApp.vue?vue&type=script&lang=js"
export * from "./WikiApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eceee29",
  null
  
)

export default component.exports